import type { MarkdownText } from "@/lib/client/maintenance-tasks";

// The first heading restates the task name the card already shows. Only the
// heading line and the blank lines after it go: the first content line keeps
// its indentation, which Markdown reads as a code block.
const LEADING_HEADING =
  /^(?:[ \t]*\n)*[ ]{0,3}#{1,6}[ \t]+[^\n]*(?:\n|$)(?:[ \t]*\n)*/;

export const withoutLeadingHeading = (description: MarkdownText) =>
  description.replace(LEADING_HEADING, "").trimEnd();

// First guess, before layout exists: whether the body likely overflows the
// clamped preview. A measured overflow replaces it once the body renders.
export const isLong = (body: string) =>
  body.trim().includes("\n") || body.length > 160;
